import ImagesMainBannerHeaderBannerGiveawayAprilWebp from '@/public/images/main-banner/header-banner/giveaway_april.webp';

export { ImagesMainBannerHeaderBannerGiveawayAprilWebp };
